<template lang="pug">
b-modal(v-model="showModal", size="lg", centered title="Submission Details" scrollable)
    .container
            div(v-if="event.isSingleDay && submission.singleDay" class="d-flex flex-column attendees-list")
                 
                div.attendee-box(v-for="person in uniquePeopleSingleDay" :key="person")
                    div(class="d-flex align-items-center" style="gap: 0.5rem;" v-if="person!=='Other Persons'")
                        b-icon-person-badge
                        b-card-text.m-0() {{ person === 'Client' ? `${currentClientName()} -` : person === 'Caregiver' ? `${currentCaregiverId()} -` : "" }}  {{ person }}
                    div.food-list(v-if="submission.singleDay.whoGoing.includes('Client') && (event.singleDay.food.lunch.length>0 || event.singleDay.food.beverages.length>0) && person === 'Client'" class="d-flex flex-column").mt-1
                        small.p.m-0(v-if="submission.singleDay.client.lunch") Client's Food Choices
                        b-card-text.m-0.font-weight-bold(v-if="submission.singleDay.client.lunch") {{ submission.singleDay.client.lunch }}
                        div.food-list(class="d-flex flex-column" v-if="event.singleDay.food.beverages.length > 0 && submission.singleDay.client.beverage").mt-1
                            small.p.m-0(v-if="submission.singleDay.client.beverage") Client's Beverage Option
                            b-card-text.m-0.font-weight-bold(v-if="submission.singleDay.client.beverage") {{ submission.singleDay.client.beverage }}
                    div.food-list(v-if="submission.singleDay.whoGoing.includes('Caregiver') && (event.singleDay.food.lunch.length>0 || event.singleDay.food.beverages.length>0) && person==='Caregiver'" class="d-flex flex-column").mt-1
                        small.p.m-0(v-if="submission.singleDay.caregiver.lunch") Caregiver's Food Choices
                        b-card-text.m-0.font-weight-bold(v-if="submission.singleDay.caregiver.lunch") {{ submission.singleDay.caregiver.lunch }}
                        div.food-list(v-if="event.singleDay.food.beverages.length > 0 && submission.singleDay.caregiver.beverage" class="d-flex flex-column").mt-1
                            small.p.m-0(v-if="submission.singleDay.caregiver.beverage") Caregiver's Beverage Option
                            b-card-text.m-0.font-weight-bold(v-if="submission.singleDay.caregiver.beverage") {{ submission.singleDay.caregiver.beverage }}
                    div(v-if="person==='Other Persons' && submission.singleDay.whoGoing.includes('Other Persons') && submission.singleDay.otherPersons.length > 0" class="d-flex flex-column").mb-2
                        b-card-text.h6 Other Persons
                        div.attendee-box(v-for="person in submission.singleDay.otherPersons" :key="person.name" class="d-flex flex-column")
                            div(class="d-flex align-items-center" style="gap: 0.5rem;")
                                b-icon-person-badge
                                b-card-text.m-0 {{ person.name }}
                            div.food-list(class="d-flex flex-column")
                                small.mt-1(v-if="person.lunch") Food Choices
                                b-card-text.m-0.font-weight-bold(v-if="person.lunch") {{ person.lunch }}
                                div.food-list(v-if="event.singleDay.food.beverages.length > 0 && person.beverage" class="d-flex flex-column")
                                    small.mt-1(v-if="person.beverage") Beverage Option
                                    b-card-text.m-0.font-weight-bold(v-if="person.beverage") {{ person.beverage }}        
                small.badge-local(style="width:fit-content;" v-if="submission?.remarks").mt-4.mb-0 Remarks You Added: 
                b-card-text.p.m-0 {{ submission?.remarks }}
                small.badge-local(style="width:fit-content;").mt-3 Total Attendees
                b-card-text.p.m-0 {{ totalAttendees }}
                small.badge-local(style="width:fit-content;" v-if="submission.totalCost !== 0").mt-3 Total Price
                b-card-text.p.m-0.text-success  {{ submission.totalCost === 0 ? "" : `$ ${ (parseFloat((submission.totalCost * (event.gst/100)).toFixed(2)) + submission?.totalCost).toFixed(2) } (after GST)` }}
                    

            div(v-if="!event.isSingleDay && submission.multipleDays" class="d-flex flex-column attendees-list")
                
                small.p.mb-1.mt-3 People Attending 
                
                div.attendee-box(v-for="person in uniquePeopleMultipleDays" :key="person")
                    div(class="d-flex align-items-center" style="gap: 0.5rem;")
                        b-icon-person-badge
                        b-card-text.m-0.h6 {{ person === 'Client' ? `${currentClientName()} -` : person === 'Caregiver' ? `${currentCaregiverId()} -` : "" }}  {{ person }}
                        
                
                    div.food-list(v-if="submission.multipleDays.whoGoing.includes('Client') && person ==='Client'" class="d-flex flex-column")

                        small.p.mb-1.mt-3 Selected Days for Client:
                        ul(class="list-unstyled" style="padding-left: 0;")
                            li.p.font-weight-bold(v-for="day in submission.multipleDays.client.attendingDays" :key="day") {{ day }}
                    
                        div.food-list(v-for="(day, index) in event.multipleEvents" :key="day.id" v-if="submission.multipleDays.client.attendingDays.includes(new Date(day.date).toLocaleDateString('en-US', {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'}))" class="d-flex flex-column mb-2")
                            small.p.mb-1() Selected Food Option for {{ new Date(day.date).toLocaleDateString('en-US', {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'}) }}
                            b-card-text.m-0.font-weight-bold {{ submission.multipleDays.client.lunchByDay.find(lunch => lunch.dayID === day.id)?.lunchOption }}
                            b-card-text.m-0.font-weight-bold {{ submission.multipleDays.client.beverageByDay.find(beverage => beverage.dayID === day.id)?.beverageOption }}
                            small.p.mb-2.text-primary(v-if="!submission.multipleDays.client.lunchByDay.find(lunch => lunch.dayID === day.id)  && !submission.multipleDays.client.beverageByDay.find(beverage => beverage.dayID === day.id) ") No Food Options Selected for this day
                
                    div.food-list(v-if="submission.multipleDays.whoGoing.includes('Caregiver')  && person ==='Caregiver'" class="d-flex flex-column")
                        small.p.mb-1.mt-3 Selected Days for Caregiver:
                        ul(class="list-unstyled" style="padding-left: 0;")
                            li.p.font-weight-bold(v-for="day in submission.multipleDays.caregiver.attendingDays" :key="day") {{ day }}
                        div.food-list(v-for="(day, index) in event.multipleEvents" :key="day.id" v-if="submission.multipleDays.caregiver.attendingDays.includes(new Date(day.date).toLocaleDateString('en-US', {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'}))" class="d-flex flex-column")
                            small.p.mb-1() Selected Food Option for {{ new Date(day.date).toLocaleDateString('en-US', {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'}) }}
                            b-card-text.m-0.font-weight-bold {{ submission.multipleDays.caregiver.lunchByDay.find(lunch => lunch.dayID === day.id)?.lunchOption }}
                            b-card-text.m-0.font-weight-bold {{ submission.multipleDays.caregiver.beverageByDay.find(beverage => beverage.dayID === day.id)?.beverageOption }}
                            small.p.mb-2.text-primary(v-if="submission.multipleDays.caregiver.lunchByDay.length === 0 && submission.multipleDays.caregiver.beverageByDay.length === 0") No Food Options Selected for this day
                        //- b-card-text(v-if="!submission.multipleDays.caregiver.lunchByDay.find(lunch => lunch.dayID === day.id) && !submission.multipleDays.caregiver.beverageByDay.find(beverage => beverage.dayID === day.id)") No Food Options Selected for this day
                    div(v-if="person === 'Other Persons' && submission.multipleDays.whoGoing.includes('Other Persons')" class="d-flex flex-column").mt-2
                        div.attendee-box(v-for="person in submission.multipleDays.otherPersons" :key="person.name" class="d-flex flex-column")
                            div(class="d-flex align-items-center" )
                                b-icon-person-badge
                                b-card-text.m-0 {{ person.name }}
                            div.food-list(v-for="(day, index) in event.multipleEvents" :key="day.id" v-if="person.attendingDays.includes(new Date(day.date).toLocaleDateString('en-US', {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'}))" class="d-flex flex-column")
                                small.p.mb-1() Selected Food Option for {{ new Date(day.date).toLocaleDateString('en-US', {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'}) }} 
                                b-card-text.m-0.font-weight-bold {{ person.lunchByDay.find(lunch => lunch.dayID === day.id)?.lunchOption }}
                                b-card-text.m-0.font-weight-bold {{ person.beverageByDay.find(beverage => beverage.dayID === day.id)?.beverageOption }}
                                small.p.mb-2.text-primary(v-if="!person.lunchByDay.find(lunch => lunch.dayID === day.id)  && !person.beverageByDay.find(beverage => beverage.dayID === day.id) ") No Food Options Selected for this day
                small.badge-local(style="width:fit-content;" v-if="submission?.remarks").mt-4.mb-0 Remarks You Added: 
                b-card-text.p.m-0.font-weight-bold {{ submission?.remarks }}
                small.badge-local(style="width:fit-content;").mt-3 Total Attendees
                b-card-text.p.m-0 {{ totalAttendees }}
                small.badge-local(style="width:fit-content;").mt-3 Total Price
                b-card-text.p.m-0.text-success $ {{  (parseFloat((submission.totalCost * (event.gst/100)).toFixed(2)) + submission?.totalCost).toFixed(2) }} (after GST)
    template(#modal-footer)
        b-button(@click="showModal = false" variant="primary") Close
</template>

<script>
    export default {
        props:{
            event:{
                type:Object,
                required:true
            },
            show:{
                type:Boolean,
                required:true
            },
            submission : {
                type:Object,
                required:true
            }
        },
        computed:{
            showModal:{
                get(){
                    return this.show;
                },
                set(value){
                    this.$emit('update:show', value);
                }
            },
            uniquePeopleSingleDay() {
                const people = [...new Set(this.submission.singleDay.whoGoing)];
                const order = ['Client', 'Caregiver', 'Other Persons'];
                return people.sort((a, b) => order.indexOf(a) - order.indexOf(b));
            },
            uniquePeopleMultipleDays() {
                const people = [...new Set(this.submission.multipleDays.whoGoing)];
                const order = ['Client', 'Caregiver', 'Other Persons'];
                return people.sort((a, b) => order.indexOf(a) - order.indexOf(b));
            },
            totalAttendees(){
                if (!this.submission) return 0;
                if (this.event && this.event.isSingleDay){
                    const who = (this.submission.singleDay && this.submission.singleDay.whoGoing) ? this.submission.singleDay.whoGoing : [];
                    const base = who.filter(p => p !== 'Other Persons').length;
                    const others = (who.includes('Other Persons') && this.submission.singleDay && Array.isArray(this.submission.singleDay.otherPersons)) ? this.submission.singleDay.otherPersons.length : 0;
                    return base + others;
                }
                const who = (this.submission.multipleDays && this.submission.multipleDays.whoGoing) ? this.submission.multipleDays.whoGoing : [];
                const base = who.filter(p => p !== 'Other Persons').length;
                const others = (who.includes('Other Persons') && this.submission.multipleDays && Array.isArray(this.submission.multipleDays.otherPersons)) ? this.submission.multipleDays.otherPersons.length : 0;
                return base + others;
            }

        },
        methods:{
            currentClientName() {
            return this.$store.state.cli_name;
        },
        currentCaregiverId() {
            return this.$store.state.currentUser[0]?.crb5c_name
        }
        }
        
    }
</script>

<style lang="scss" scoped>

.attendees-list .attendee-box {
    background-color: #f7f7f7; // light gray box
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    padding: 12px;
    margin-bottom: 8px;
}
.attendees-list .attendee-box:last-child {
    margin-bottom: 0;
}
.food-list {
    margin-top: 4px;
}
.food-list p,
.food-list .b-card-text,
.food-list small {
    margin-bottom: 2px !important;
}

</style>